import api from './api';

export const scheduleService = {
  getAll: (params = {}) => api.get('/schedule/', { params }),
  getById: (id) => api.get(`/schedule/${id}`),
  create: (data) => api.post('/schedule/', data),
  update: (id, data) => api.put(`/schedule/${id}`, data),
  updateStatus: (id, status, notes) => api.put(`/schedule/${id}/status`, { status, notes }),
  delete: (id) => api.delete(`/schedule/${id}`),
  getTeamSchedule: (teamId, params = {}) => api.get(`/schedule/team/${teamId}`, { params }),
  getTodaySummary: () => api.get('/schedule/today/summary'),
};
